import casesEvents from '@shared/analytics/events/casesEvents';
import clientEvents from '@shared/analytics/events/clientEvents';
import miscellaneousEvents from '@shared/analytics/events/miscellaneousEvents';
import proposalsEvents from '@shared/analytics/events/proposalsEvents';
import vaultEvents from '@shared/analytics/events/vaultEvents';
import bankProductsEvents from '@shared/analytics/events/bankProductsEvents';
import creditEvents from '@shared/analytics/events/creditEvents';
import referAndEarnEvents from '@shared/analytics/events/referAndEarnEvents';

export const USER_EVENTS = {
  CLIENT: clientEvents,
  VAULT: vaultEvents,
  PROPOSAL: proposalsEvents,
  CASE: casesEvents,
  MISCELLANEOUS: miscellaneousEvents,
  BANK_PRODUCTS: bankProductsEvents,
  CREDITS: creditEvents,
  REFER_AND_EARN: referAndEarnEvents,
};
